import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import * as echarts from "echarts";
import _ from 'lodash';


export const ChartDescriptiveSection1 = (props) => {
    const { jsonData, chartName, chartHeight } = props;
    const { t } = useTranslation();
    const chartRef = React.useRef(null);
    const myChart = React.useRef(null);

    React.useEffect(() => {
        if (!myChart.current && chartRef.current) {
            myChart.current = echarts.init(chartRef.current);
        }

        const option = {
            name: chartName || '',
            silent: true,
            textStyle: {
                fontSize: Math.round(myChart.current._dom.offsetWidth) < 400 ? 8 : 12,
                fontWeight: 'bold'
            },
            series: [{
                radius: ['15%', '80%'],
                type: 'sunburst',
                sort: undefined,
                emphasis: {
                  focus: 'ancestor'
                },
                data: jsonData || [],
                label: {
                    formatter: function (param) {
                        let depth = param.treePathInfo.length;
                        if (depth === 4) {
                            return '';
                        }
                        return t(`assessment.${param.name.toLowerCase().trim().replace(' ', '')}`) + '\n' + param.value;
                    }
                },
                levels: [{},
                {
                    itemStyle: {
                        color: '#CD4949'
                    },
                    label: {
                        rotate: 'radial'
                    }
                },
                {
                    itemStyle: {
                        color: '#F47251'
                    },
                    label: {
                        rotate: 'tangential'
                    }
                },
                {
                    itemStyle: {
                        color: '#FFC75F'
                    },
                    label: {
                        rotate: 0
                    }
                }]
            }]
        };

        if (myChart.current) {
            myChart.current.showLoading();
            myChart.current.setOption(option);
            myChart.current.hideLoading();
        }
        
        
        // 창크기 변경할때 카트를 갱신한다.
        const handleResize = _.debounce(() => {
            if (myChart.current) {
                myChart.current.showLoading();
                myChart.current.setOption(option);
                myChart.current?.resize();
                myChart.current.hideLoading();
            }
        }, 50); // Debounce for 50ms

        window.addEventListener('resize', handleResize);

        return () => {
            try {
                window.removeEventListener('resize', handleResize);
            
                myChart.current && myChart.current.dispose();
                myChart.current && myChart.current.dispose();
                myChart.current = null;
            }
            catch (err) {
                console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
            }
        };
    }, [jsonData, chartName, chartHeight]);


    return <div ref={chartRef} style={{ width: "100%", height: chartHeight || "400px" }} />;
};

ChartDescriptiveSection1.propTypes = {
    jsonData: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
    chartName: PropTypes.string,
    chartHeight: PropTypes.string,
};
